import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=ab7b3dd0&"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js&"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports